/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/209-eye-minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10 2h6v2h-6V2z"/><path pid="1" d="M13.599 5H9V3.056A8.923 8.923 0 008 3C4.511 3 1.486 5.032 0 8c1.486 2.968 4.511 5 8 5s6.514-2.032 8-5a9.173 9.173 0 00-2.401-3zM6.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 016.5 5zm5.444 5.348a7.326 7.326 0 01-7.889 0A7.626 7.626 0 011.72 8a7.594 7.594 0 012.52-2.462 4 4 0 107.518 0A7.615 7.615 0 0114.278 8a7.594 7.594 0 01-2.335 2.348z"/>'
  }
})
